import Store from '../../../../redux';


// API BASE path, change this accordingly OR put it in env variable for different envs.
const API_BASE = process.env.REACT_APP_API_URL_STOCK+"/";

const symbolToToken = new Map();

let patternData = {};
const getHeaders = () => {
  const user = Store?.getState()?.user;
  return {
    'X-FNOTRADER-SECRET': user?.loginSecret,
    'X-FNOTRADER-USERID': user?.userID,
  };
};

export async function getsearchAPI(params) {
  try {
   
    const response = await fetch(`${API_BASE}${`ov5/search?query=${encodeURIComponent(params)}&filter=`}`, {
      redirect: "follow",
      headers: {}
    });
    return response.json();
  } catch (error) {
    throw new Error(`API request error: ${error.status}`);
  }
}

// Make requests to the API
export async function fnoTraderApiRequest(path) {
  try {
     
    const response = await fetch(`${API_BASE}${path}`, {
      redirect: "follow",
      headers: getHeaders()
    });
    return response.json();
  } catch (error) {
    throw new Error(`API request error: ${error.status}`);
  }
}

export function getSymbolToTokenFromMap(symbol) {
  try {
    if (symbolToToken.has(symbol)) {
      return symbolToToken.get(symbol);
    }
    return "";
  } catch (err) {
    console.error("looking for symbol which is not is the current map");
    return "";
  }
}

export async function setToken(symbol, theToken) {
  symbolToToken.set(symbol, `${theToken}`);
}

export async function getTokenByName(symbolInput) {
  try {
    let symbol = symbolInput;

    if (symbolInput.includes("#")) {
      symbol = symbolInput.split("#")[0];
    }
    

    if (symbolToToken.has(symbol)) {
      return symbolToToken.get(symbol);
    }

    const values = await getsearchAPI(symbol);
  //  const { values = [] } = data;
    const theToken =
    values.data.values.find((value) => value.name === symbol)?.token || "";

    symbolToToken.set(symbol, `${theToken}`);
 
    return `${theToken}`;
  } catch (e) {
    console.error(`error getting token for the symbol `);
    throw e;
  }
}

export async function getTokenBySymbol(symbolInput) {
  try {
    let symbol = symbolInput;

    if (symbolInput.includes("#")) {
      symbol = symbolInput.split("#")[0];
    }
    

    if (symbolToToken.has(symbol)) {
      return symbolToToken.get(symbol);
    }

    const values = await getsearchAPI(symbol);
  //  const { values = [] } = data;
    const theToken =
      values.data.values.find((value) => value.symbol === symbol)?.token || "";
 
    symbolToToken.set(symbol, `${theToken}`);
   
    return `${theToken}`;
  } catch (e) {
    console.error(`error getting token for the symbol `);
    throw e;
  }
}

export function unixToDateString(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

 

export function transformData(data, whichCustomIndicator, resolution) {
  const { o: opens, h, l, c, v, t, d, cd, oi, oi1, oi2, oi3, del } = data;
  const historyData = [];
   
  let openSelector = "o";
  let highSelector = "h";
  let lowSelector = "l";
  let closeSelector = "c";
  let closeValue = 0; 
  if (!!whichCustomIndicator) {
    closeSelector = whichCustomIndicator;
  }

  if (whichCustomIndicator === "deltabars" && resolution != "1D") {
    openSelector = "cdo";
    highSelector = "cdh";
    lowSelector = "cdl";
    closeSelector = "cdc";
  }

  if (whichCustomIndicator === "FTGreeksDeltaBars" && resolution != "1D") {
    openSelector = "dc";
    highSelector = "dh";
    lowSelector = "do";
    closeSelector = "dl";
  }
  
  if (whichCustomIndicator === "FTGreeksThetaBars" && resolution != "1D") {
    openSelector = "tc";
    highSelector = "th";
    lowSelector = "to";
    closeSelector = "tl";
  }

  if (whichCustomIndicator === "FTGreeksVegaBars" && resolution != "1D") {
    openSelector = "vc";
    highSelector = "vh";
    lowSelector = "vo";
    closeSelector = "vl";
  }
  if (whichCustomIndicator === "FTGreeksGammaBars" && resolution != "1D") {
    openSelector = "gc";
    highSelector = "gh";
    lowSelector = "go";
    closeSelector = "gl";
  }

  if (whichCustomIndicator === "FTIVBars" && resolution != "1D") {
    openSelector = "ivo";
    highSelector = "ivh";
    lowSelector = "ivl";
    closeSelector = "ivc";
  }


 

  patternData = {};
  opens.forEach((o, i) => {

     if(whichCustomIndicator === "FTcumoiINT" && resolution == "1D") {
       closeValue = oi1[i]+oi2[i]+oi3[i];
     } else if(((closeSelector == "deltabars" || closeSelector == "cd" || closeSelector == "d") && resolution == "1D")) {
      closeValue = 0;
     }else if((closeSelector == "FTcumoiINT" || closeSelector=="del") &&  resolution != "1D") {
      closeValue  = 0;
     } else {
      closeValue = data[closeSelector][i];
     }

    const tt = t[i] * 1000;
    const open =
    whichCustomIndicator === "FTIVBars" || whichCustomIndicator === "deltabars" || whichCustomIndicator === "FTGreeksDeltaBars" || whichCustomIndicator === "FTGreeksThetaBars" ||  whichCustomIndicator === "FTGreeksVegaBars"  || whichCustomIndicator == "FTGreeksGammaBars" ? data[openSelector][i] : o;
    const high = data[resolution == "1D" ? "h" : highSelector][i];
    const low = data[resolution == "1D" ? "l" : lowSelector][i];
    const close = closeValue;//whichCustomIndicator === "FTcumoiINT" && resolution == "1D" ? oi1[i]+oi2[i]+oi3[i] :  ((closeSelector == "deltabars" || closeSelector == "cd" || closeSelector == "d") && resolution == "1D")  ? 0 :  data[closeSelector][i];
    const volume = v[i];
    const delta = resolution == "1D" ? 0 : d[i];
    const cumulativeDelta = resolution == "1D" ? 0 :  cd[i];
    const openInterest = oi[i];
    const oicumulative = resolution == "1D"  ? oi1[i]+oi2[i]+oi3[i] : 0;  

    historyData.push({
      time: tt,
      open,
      high,
      low,
      close,
      volume,
      delta,
      oicumulative,
       
    });

    

    patternData[tt] = {
      delta,
      cumulativeDelta,
      openInterest,
    };
  });

  return historyData;
}
 

export const resolutionsMap = {
  1: "1m",
  3: "3m",
  5: "5m",
  10: "10m",
  15: "15m",
  30: "30m",
  60: "1h",
  "1D": "1d",
  "1W": "1W",
  "1M": "1M",
};



 
